import { AuthenticationType, CBSDCategory, Cipher, Compression, ConnectionMode, ConnectionType, EncryptionKeyLength, EncryptionMode, GreMode, Hash, IpsecIdType, L2TPAuthenticationType, L2TPConnectionType, L2TPIkeModeOptions, L2TPVersion, OpenVpnTunnelProtocol, OpenVpnTunnelType, PreSharedKeyFormat, ProtocolBindingProtocol, RadioActive, SelectOption, SupportDeviceModel, V3EncapMode } from "@core/types";

export const INITIAL_ACCESS_CONTROL_VALUE = {
    Activate: 'No',
    ScrIPAddrBegin: '0.0.0.0',
    ScrIPAddrEnd: '0.0.0.0',
    Application: 'Web',
    Interface: 'WAN'
};

export const INITIAL_UD_APP_VALUE = {
    userapp: 'No',
    uname: '',
    uproto: 'UDPTCP',
    uport: ''
};

export const INITIAL_IP_MAC_FILTER_VALUE = {
    Active: 'No',
    Interface: 'PVC11',
    EwanIndex: '0',
    Direction: 'Both',
    RuleType: 'IP',
    SrcIPAddr: '0.0.0.0',
    SrcIPMask: '0.0.0.0',
    SrcIPv6Addr: '0:0:0:0:0:0:0:0',
    SrcPrefix: '32',
    SrcPort: 0,
    DesIPAddr: '0.0.0.0',
    DesIPMask: '0.0.0.0',
    DesIPv6Addr: '0:0:0:0:0:0:0:0',
    DesPrefix: '32',
    DesPort: 0,
    DSCP: 64,
    Protocol: 'ANY',
    MacAddr: '',
    timeschid: '99'
};

export const INITIAL_URL_FILTER_VALUE = {
    Activate: '0',
    URL: '',
    timeschid: '99'
};

export const INITIAL_DOMAIN_FILTER_VALUE = {
    Activate: '0',
    DOMAIN: ''
};

export const INITIAL_USER_ACCOUNT_VALUE = {
    username: '',
    web_passwd: '',
    web_passwd_confirm: '',
    ftp_active: 'No',
    ftp_permission: '0',
    samba_active: 'No',
    samba_permission: '0',
    guestAccount: '0',
    vpn: '1',
    voip: '1',
    maintence: '1',
    access: '1',
    advanced: '1',
    _interface: '1',
    hotSpot: '1'
};

export const INITIAL_AUTO_REBOOT_SCHEDULE_VALUE = {
    Enable: 'No',
    StartTime: { hour: 0, minute: 0, second: 0 },
    Mon: false,
    Tue: false,
    Wed: false,
    Thu: false,
    Fri: false,
    Sat: false,
    Sun: false
};

export const INITIAL_IPSEC_VALUE = {
    Connection_Name: "",
    IPSEC_Active: "Yes",
    IPSEC_VCIndex: "99",
    Gateway_IP: "",
    Local_SubnetOrIP: "Subnet",
    Local_IP: "0.0.0.0",
    Local_SubnetMask: "0.0.0.0",
    Local_EXTIP: "0.0.0.0",
    Local_EXTSubnet: "0.0.0.0",
    Remote_SubnetOrIP: "Subnet",
    Remote_IP: "0.0.0.0",
    Remote_SubnetMask: "0.0.0.0",
    Remote_IP1: "0.0.0.0",
    Remote_SubnetMask1: "0.0.0.0",
    Remote_IP2: "0.0.0.0",
    Remote_SubnetMask2: "0.0.0.0",
    Vs: false,
    VSEL: "0",
    P0: "TCP",
    SP0: 0,
    EP0: 0,
    DIP0: "",
    LIP0: "",
    P1: "TCP",
    SP1: 0,
    EP1: 0,
    DIP1: "",
    LIP1: "",
    P2: "TCP",
    SP2: 0,
    EP2: 0,
    DIP2: "",
    LIP2: "",
    P3: "TCP",
    SP3: 0,
    EP3: 0,
    DIP3: "",
    LIP3: "",
    Phase1_Mode: IpsecIdType.DEFAULT,
    LIDType: "0",
    LIDContent: '',
    RIDType: "0",
    RIDContent: '',
    PSK_Format: PreSharedKeyFormat.TEXT,
    PreShared_Key: '',
    Phase1_EncryptAlgo: "0",
    Phase1_AuthAlgo: "0",
    Phase1_DhGroup: "0",
    IPSEC_Type: "ESP",
    Phase2_EncryptAlgo: "0",
    Phase2_AuthAlgo: "0",
    Phase2_PfsGroup: "0",
    KeepAlive: "0",
    PingIP: "0.0.0.0",
    Phase1_KeyLifeTime: 480,
    Phase2_KeyLifeTime: 60,
    IPSec_Interval: 10,
    DpdTimeout: 180,
    ReconnInterval: 3
};

export const INITIAL_PPTP_SERVER_RULE_VALUE = {
    Name: '',
    Active: 'No',
    Username: '',
    Password: '',
    ConnectionType: ConnectionType.REMOTE_ACCESS,
    AssignedIP: '',
    PeerNetwork: '',
    Netmask: ''
};

export const INITIAL_PPTP_CLIENT_RULE_VALUE = {
    Name: '',
    Active: 'No',
    AuthType: AuthenticationType.CHAP_PAP,
    EnpType: EncryptionKeyLength.AUTO,
    EnpMode: EncryptionMode.AUTO,
    CCP: 'Yes',
    Username: '',
    Password: '',
    ConnectionType: ConnectionType.REMOTE_ACCESS,
    ServerIP: '',
    PeerNetwork: '',
    Netmask: '',
    FixAct: false,
    FixIp: '',
    ActiveDR: false,
    Dmz: false,
    Dmzip: '',
    Vs: false,
    VSEL: "0",
    P0: "TCP",
    SP0: 0,
    EP0: 0,
    LIP0: "",
    P1: "TCP",
    SP1: 0,
    EP1: 0,
    LIP1: "",
    P2: "TCP",
    SP2: 0,
    EP2: 0,
    LIP2: "",
    P3: "TCP",
    SP3: 0,
    EP3: 0,
    LIP3: ""
};

export const INITIAL_L2TP_VALUE = {
    DName: '',
    Active: 'No',
    Ver: L2TPVersion.V2,
    Type: ConnectionMode.DIAL_IN,
    ServerIP: '',
    Authtype: L2TPAuthenticationType.CHAP_PAP,
    Username: '',
    Password: '',
    RemoteAccept: 'No',
    AssignedIP: '',
    ConnectionType: L2TPConnectionType.REMOTE_ACCESS,
    PeerNetwork: '',
    Netmask: '',
    FixAct: false,
    FixIp: '',
    Tunnelauth: false,
    Secret: '',
    Lhostname: '',
    Rhostname: '',
    ActiveDR: false,
    TCP_MSS: 0,
    IPSec_Enable: false,
    IKE_Mode: L2TPIkeModeOptions.MAIN,
    IKE_LIDType: IpsecIdType.DEFAULT,
    IIKE_LID: '',
    IKE_RIDType: IpsecIdType.DEFAULT,
    IKE_RID: '',
    IKE_PSK: '',
    Dmz: false,
    Dmzip: '',
    Vs: false,
    VSEL: "0",
    P0: "TCP",
    SP0: 0,
    EP0: 0,
    LIP0: "",
    P1: "TCP",
    SP1: 0,
    EP1: 0,
    LIP1: "",
    P2: "TCP",
    SP2: 0,
    EP2: 0,
    LIP2: "",
    P3: "TCP",
    SP3: 0,
    EP3: 0,
    LIP3: "",
    pvc: "PVC11",
    v3EncapMode: V3EncapMode.IP,
    v3Rhost: "",
    v3Ludp: 0,
    v3Rudp: 0,
    v3Tunaddr: "",
    v3RTunaddr: "",
    v3Tunid: 1,
    v3RTunid: 1,
    v3Sesid: 1,
    v3RSesid: 1,
    v3Mtu: 1488,
    v3Bridge: "Yes"
};

export const INITIAL_GRE_VALUE = {
    showname: '',
    Activate: 'Yes',
    mode: GreMode.TUN,
    bridge: 'No',
    pvc: 'PVC11',
    remotegw: '0.0.0.0',
    tunnelip: '0.0.0.0',
    tunnelmask: '0.0.0.0',
    peerip: '0.0.0.0',
    remoteSubnetIP: '0.0.0.0',
    remoteSubnetMask: '0.0.0.0',
    keepalive: false,
    keepalivetime: 3,
    keepaliveinterval: 5,
    key: '',
    NAT: 'No',
    DefRoute: 'No',
    IPSec_Enable: false,
    IKE_Mode: 'Main',
    IKE_LIDType: '0',
    IKE_LID: '',
    IKE_RIDType: '0',
    IKE_RID: '',
    IKE_PSK: ''
};

export const INITIAL_OPEN_VPN_CLIENT_VALUE = {
    Name: '',
    Active: 'No',
    DevType: OpenVpnTunnelType.TUN,
    Bridge: 'Yes',
    ServerAddr: '',
    ServerPort: 1194,
    Proto: OpenVpnTunnelProtocol.UDP,
    Redirect: 'No',
    RemoteNetIP: '',
    RemoteNetMask: '255.255.255.0',
    NATType: '',
    NATNetIP: '',
    NATNetMask: '255.255.255.0',
    NATAlias: '',
    CertIndex: '',
    CAIndex: '',
    AuthUsername: '',
    AuthPassword: '',
    TlsAuth: 'No',
    KeyDirection: '1',
    TlsAuthKey: '',
    Cipher: Cipher.AES_128_CBC,
    Digest: Hash.SHA256,
    Comp: Compression.ADAPTIVE,
    Keepalive: true,
    KeepaliveInt: 10,
    KeepaliveTimeout: 120
};

export const OPENWRT_NETWORK_MODE: Array<SelectOption> = [
    { value: "3", name: "LTE Only" },
    { value: "15", name: "5G only (SA mode)" },
    { value: "19", name: "LTE + 5G" },
    { value: "21", name: "Automatic" }
];

export const OPENWRT_PING_COUNT: Array<SelectOption> = [
    { value: "1", name: "1" },
    { value: "2", name: "2" },
    { value: "3", name: "3" },
    { value: "4", name: "4" },
    { value: "5", name: "5" },
    { value: "6", name: "6" },
    { value: "7", name: "7" },
    { value: "8", name: "8" },
    { value: "9", name: "9" },
    { value: "10", name: "10" }
];

export const OPENWRT_PING_INTERVAL: Array<SelectOption> = [
    { value: "5", name: "5 seconds" },
    { value: "10", name: "10 seconds" },
    { value: "20", name: "20 seconds" },
    { value: "30", name: "30 seconds" },
    { value: "60", name: "1 minute" },
    { value: "300", name: "5 minutes" },
    { value: "600", name: "10 minutes" },
    { value: "900", name: "15 minutes" },
    { value: "1800", name: "30 minutes" },
    { value: "3600", name: "1 hour" }
];

export const OPENWRT_PING_TIMEOUT: Array<SelectOption> = [
    { value: "1", name: "1 second" },
    { value: "2", name: "2 seconds" },
    { value: "3", name: "3 seconds" },
    { value: "4", name: "4 seconds" },
    { value: "5", name: "5 seconds" },
    { value: "6", name: "6 seconds" },
    { value: "7", name: "7 seconds" },
    { value: "8", name: "8 seconds" },
    { value: "9", name: "9 seconds" },
    { value: "10", name: "10 seconds" }
];

export const INITIAL_ROUTING_VALUE = {
    DST_IP: '0.0.0.0',
    Sub_mask: '0.0.0.0',
    Switcher: '0',
    Gateway: '0.0.0.0',
    Device: 'PVC11',
    metric: 1
};

export const INITIAL_IPV6_ROUTING_VALUE = {
    DST_IP: '::1',
    Prefix: '128',
    Switcher: '0',
    Gateway: '::',
    Device: 'PVC11',
    metric: 2048
};

export const INITIAL_OSPF_VALUE = {
    PVC: '11',
    AREA: ''
};

export const INITIAL_BGP_VALUE = {
    NEIP: '',
    NEASN: 1,
    NEIN: false,
    NHS: false,
    NESRI: false,
    NEMHOP: false
};

export const INITIAL_DMZ_VALUE = {
    ExpPort: 0,
    PROTOCOL: 'TCP',
    Descript: 0
};

export const INITIAL_VIRTUAL_SERVER_VALUE = {
    PROTOCOL: 'TCP',
    STARTPORT: 0,
    ENDPORT: 0,
    LOCALIP: '0.0.0.0',
    LOCAL_SPORT: 0,
    LOCAL_EPORT: 0,
    expact: '1',
    sipstart: '0.0.0.0',
    sipend: '0.0.0.0'
};

export const INIITIAL_STATIC_DNS = {
    IPAddr: "",
    DomainName: ""
};

export const INITIAL_PROTOCOL_BINDING_VALUE = {
    Active: RadioActive.YES,
    Interface: "1",
    SrcIPAddr: "0.0.0.0",
    SrcIPMask: "0.0.0.0",
    SrcPort: 0,
    DesIPAddr: "0.0.0.0",
    DesIPMask: "0.0.0.0",
    DesPort: 0,
    DSCP: 64,
    Protocol: ProtocolBindingProtocol.ANY,
    e1: 'No',
    e2: 'No',
    e3: 'No',
    w0: 'No',
    w1: 'No',
    w2: 'No',
    w3: 'No',
    r0: 'No',
    r1: 'No',
    r2: 'No',
    r3: 'No'
};

export const INITIAL_LAN_HOST_BANDWIDTH = {
    mac: "",
    dwbw: 100,
    upbw: 100
};

export const INITIAL_QOS_RULE = {
    APPVAL: "",
    DirType: "L2W",
    WanPVC: "0",
    RateType: "MAX",
    PriType: "0",
    EachLan: "0",
    RATE: 1,
    DscpMark: "0xFF",
    ProType: "ANY",
    INTIPEADD: "0.0.0.0",
    INTIPSADD: "0.0.0.0",
    INTPORS: 0,
    INTPORE: 0,
    EXTIPSADD: "0.0.0.0",
    EXTIPEADD: "0.0.0.0",
    EXTPORS: 0,
    EXTPORE: 0
};

export const CBSD_FCC_ID_MAP: { [key: string]: string } = {
    [SupportDeviceModel._6900]: "QI3BEC-6900R21",
    [SupportDeviceModel._7000]: "QI3BEC-7000R28G",
    [SupportDeviceModel._8231]: "QI3BEC-8231",
    [SupportDeviceModel._8232]: "QI3BEC-8231",
    [SupportDeviceModel.MX_220]: "QI3BEC-MX220UTAB",
    [SupportDeviceModel.MX_220_UT]: "QI3BEC-MX220UTAB",
    [SupportDeviceModel.MX_220_UT_5G]: "QI3BECMX220UT5GAB",
    [SupportDeviceModel.MX_220_UT__5G]: "QI3BECMX220UT5GAB"
};

export const CBSD_MX_220_UT_5G_FCC_ID_MAP: { [key: string]: string } = {
    [CBSDCategory.A]: "QI3BECMX220UT5GAB",
    [CBSDCategory.B]: "QI3BEC-MX220UT5GC"
};

export const US_5G_CHANNEL_LIST: Array<number> = [
    36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144, 149, 153, 157, 161, 165
];

export const GENERAL_5G_CHANNEL_LIST: Array<number> = [
    100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144
];

export const AU_5G_CHANNEL_LIST: Array<number> = [
    100, 104, 108, 112, 116, 132, 136, 140, 144
];

export const OPENWRT_LTE_BAND = {
    [SupportDeviceModel.M_300AX]: [
        { name: 'B1', value: '1' },
        { name: 'B8', value: '8' },
        { name: 'B41', value: '41' },
        { name: 'B42', value: '42' }
    ],
    [SupportDeviceModel._8355P]: [
        { name: 'B2', value: '2' },
        { name: 'B4', value: '4' },
        { name: 'B5', value: '5' },
        { name: 'B7', value: '7' },
        { name: 'B12', value: '12' },
        { name: 'B13', value: '13' },
        { name: 'B14', value: '14' },
        { name: 'B17', value: '17' },
        { name: 'B25', value: '25' },
        { name: 'B26', value: '26' },
        { name: 'B29', value: '29' },
        { name: 'B30', value: '30' },
        { name: 'B38', value: '38' },
        { name: 'B41', value: '41' },
        { name: 'B42', value: '42' },
        { name: 'B43', value: '43' },
        { name: 'B46', value: '46' },
        { name: 'B48', value: '48' },
        { name: 'B66', value: '66' },
        { name: 'B70', value: '70' },
        { name: 'B71', value: '71' }
    ],
    [SupportDeviceModel._8355PU]: [
        { name: 'B2', value: '2' },
        { name: 'B4', value: '4' },
        { name: 'B5', value: '5' },
        { name: 'B7', value: '7' },
        { name: 'B12', value: '12' },
        { name: 'B13', value: '13' },
        { name: 'B14', value: '14' },
        { name: 'B17', value: '17' },
        { name: 'B25', value: '25' },
        { name: 'B26', value: '26' },
        { name: 'B29', value: '29' },
        { name: 'B30', value: '30' },
        { name: 'B38', value: '38' },
        { name: 'B41', value: '41' },
        { name: 'B42', value: '42' },
        { name: 'B43', value: '43' },
        { name: 'B46', value: '46' },
        { name: 'B48', value: '48' },
        { name: 'B66', value: '66' },
        { name: 'B70', value: '70' },
        { name: 'B71', value: '71' }
    ],
    default: [
        { name: 'B2', value: '2' },
        { name: 'B4', value: '4' },
        { name: 'B5', value: '5' },
        { name: 'B7', value: '7' },
        { name: 'B12', value: '12' },
        { name: 'B13', value: '13' },
        { name: 'B14', value: '14' },
        { name: 'B17', value: '17' },
        { name: 'B25', value: '25' },
        { name: 'B26', value: '26' },
        { name: 'B29', value: '29' },
        { name: 'B30', value: '30' },
        { name: 'B38', value: '38' },
        { name: 'B41', value: '41' },
        { name: 'B42', value: '42' },
        { name: 'B43', value: '43' },
        { name: 'B46', value: '46' },
        { name: 'B48', value: '48' },
        { name: 'B66', value: '66' },
        { name: 'B70', value: '70' },
        { name: 'B71', value: '71' }]
};

export const OPENWRT_NR_BAND = {
    [SupportDeviceModel.M_300AX]: [
        { name: "n3", value: "3" },
        { name: "n28", value: "28" },
        { name: "n41", value: "41" },
        { name: "n77", value: "77" },
        { name: "n78", value: "78" },
        { name: "n79", value: "79" }
    ],
    [SupportDeviceModel._8355P]: [
        { name: "n2", value: "2" },
        { name: "n5", value: "5" },
        { name: "n7", value: "7" },
        { name: "n12", value: "12" },
        { name: "n13", value: "13" },
        { name: "n14", value: "14" },
        { name: "n25", value: "25" },
        { name: "n26", value: "26" },
        { name: "n29", value: "29" },
        { name: "n30", value: "30" },
        { name: "n38", value: "38" },
        { name: "n41", value: "41" },
        { name: "n48", value: "48" },
        { name: "n66", value: "66" },
        { name: "n70", value: "70" },
        { name: "n71", value: "71" },
        { name: "n77", value: "77" },
        { name: "n78", value: "78" }
    ],
    [SupportDeviceModel._8355PU]: [
        { name: "n2", value: "2" },
        { name: "n5", value: "5" },
        { name: "n7", value: "7" },
        { name: "n12", value: "12" },
        { name: "n13", value: "13" },
        { name: "n14", value: "14" },
        { name: "n25", value: "25" },
        { name: "n26", value: "26" },
        { name: "n29", value: "29" },
        { name: "n30", value: "30" },
        { name: "n38", value: "38" },
        { name: "n41", value: "41" },
        { name: "n48", value: "48" },
        { name: "n66", value: "66" },
        { name: "n70", value: "70" },
        { name: "n71", value: "71" },
        { name: "n77", value: "77" },
        { name: "n78", value: "78" }
    ],
    default: [
        { name: "n2", value: "2" },
        { name: "n5", value: "5" },
        { name: "n7", value: "7" },
        { name: "n12", value: "12" },
        { name: "n13", value: "13" },
        { name: "n14", value: "14" },
        { name: "n25", value: "25" },
        { name: "n26", value: "26" },
        { name: "n29", value: "29" },
        { name: "n30", value: "30" },
        { name: "n38", value: "38" },
        { name: "n41", value: "41" },
        { name: "n48", value: "48" },
        { name: "n66", value: "66" },
        { name: "n70", value: "70" },
        { name: "n71", value: "71" },
        { name: "n77", value: "77" },
        { name: "n78", value: "78" }
    ]
};

export const OPENWRT_NETWORK_MODE_OPTIONS: Array<SelectOption> = [
    { name: 'WCDMA only', value: '1' },
    { name: 'Automatic', value: '21' },
    { name: 'LTE only', value: '3' },
    { name: '5G Only (SA mode)', value: '15' },
    { name: 'LTE + 5G', value: '19' },
];

export const OPENWRT_ACS_DEVICE_DATA_MODEL_OPTIONS: Array<SelectOption> = [
    { name: 'TR098', value: '0' },
    { name: 'TR181', value: '1' }
];

export const OPENWRT_ACS_INTERFACE_OPTIONS: Array<SelectOption> = [
    { name: 'unspecified', value: '' },
    { name: 'wan', value: 'wan' }
];

export const OPENWRT_WIFI_ACCESS_POINT_OPTIONS: Array<SelectOption> = [
    { name: 'Enable', value: '0' },
    { name: 'Disable', value: '1' }
];

export const OPENWRT_WIFI_24G_WIRELESS_MODE_OPTIONS: Array<SelectOption> = [
    { name: '802.11 ax', value: '11ax' },
    { name: '802.11 n', value: '11n' },
    { name: '802.11 n+g', value: '11ng' },
    { name: '802.11 b+g', value: '11bg' }
];

export const OPENWRT_WIFI_5G_WIRELESS_MODE_OPTIONS: Array<SelectOption> = [
    { name: '802.11 ax', value: '11ax' },
    { name: '802.11 ac', value: '11ac' },
    { name: '802.11 n', value: '11n' },
    { name: '802.11 a', value: '11a' }
];

export const OPENWRT_WIFI_24G_BANDWIDTH_OPTIONS: Array<SelectOption> = [
    { name: '20 MHz', value: '[SHORT-GI-20]' },
    { name: '20/40 MHz', value: '[HT40-][HT40+][SHORT-GI-20][SHORT-GI-40]' }
];

export const OPENWRT_WIFI_5G_BANDWIDTH_OPTIONS: Array<SelectOption> = [
    { name: '20 MHz', value: '[SHORT-GI-20]' },
    { name: '40 MHz', value: '[HT40+][HT40-]' },
    { name: '80 MHz', value: '80' }
];

export const OPENWRT_WIFI_IGNORE_BROADCAST_SSID_OPTIONS: Array<SelectOption> = [
    { name: 'Disable', value: '1' },
    { name: 'Enable', value: '0' }
];

export const OPENWRT_WIFI_SECURITY_TYPE_OPTIONS: Array<SelectOption> = [
    { name: 'OPEN', value: 'OPEN' },
    { name: 'WEP 64-bit', value: 'WEP-64Bits' },
    { name: 'WEP 128-bit', value: 'WEP-128Bits' },
    { name: 'WPA-PSK', value: 'WPAPSK' },
    { name: 'WPA2-PSK', value: 'WPA2PSK' },
    { name: 'WPA3 SAE', value: 'WPA3SAE' },
    { name: 'Mixed WPA2/WPA3-PSK SAE', value: 'WPAPSKWPA2PSKSAE' },
];

export const OPENWRT_WIFI_WPA_PAIRWISE_OPTIONS: Array<SelectOption> = [
    { name: 'AES', value: 'CCMP' },
    { name: 'TKIP', value: 'TKIP' }
];

export const OPENWRT_INITIAL_AUTO_REBOOT_SCHEDULE_VALUE = {
    enable: 'D',
    mm: 0,
    hh: 0,
    Sun: false,
    Mon: false,
    Tue: false,
    Wed: false,
    Thu: false,
    Fri: false,
    Sat: false
};

export const OPENWRT_AUTO_REBOOT_DAYS_MAPPING = {
    Sun: '0',
    Mon: '1',
    Tue: '2',
    Wed: '3',
    Thu: '4',
    Fri: '5',
    Sat: '6'
};

export const WI_FI_COUNTRY_OPTION: Array<SelectOption> = [
    { value: "ALBANIA", name: "ALBANIA" },
    { value: "ALGERIA", name: "ALGERIA" },
    { value: "ARGENTINA", name: "ARGENTINA" },
    { value: "ARMENIA", name: "ARMENIA" },
    { value: "AUSTRALIA", name: "AUSTRALIA" },
    { value: "AUSTRIA", name: "AUSTRIA" },
    { value: "AZERBAIJAN", name: "AZERBAIJAN" },
    { value: "BAHRAIN", name: "BAHRAIN" },
    { value: "BELARUS", name: "BELARUS" },
    { value: "BELGIUM", name: "BELGIUM" },
    { value: "BELIZE", name: "BELIZE" },
    { value: "BOLVIA", name: "BOLVIA" },
    { value: "BRAZIL", name: "BRAZIL" },
    { value: "BRUNEI DARUSSALAM", name: "BRUNEI DARUSSALAM" },
    { value: "BULGARIA", name: "BULGARIA" },
    { value: "CANADA", name: "CANADA" },
    { value: "CHILE", name: "CHILE" },
    { value: "CHINA", name: "CHINA" },
    { value: "COLOMBIA", name: "COLOMBIA" },
    { value: "COSTA RICA", name: "COSTA RICA" },
    { value: "CROATIA", name: "CROATIA" },
    { value: "CYPRUS", name: "CYPRUS" },
    { value: "CZCH REPUBLIC", name: "CZCH REPUBLIC" },
    { value: "DENMARK", name: "DENMARK" },
    { value: "DOMINICAN REPUBLIC", name: "DOMINICAN REPUBLIC" },
    { value: "ECUADOR", name: "ECUADOR" },
    { value: "EGYPT", name: "EGYPT" },
    { value: "ELSALVADOR", name: "ELSALVADOR" },
    { value: "FINLAND", name: "FINLAND" },
    { value: "FRANCE", name: "FRANCE" },
    { value: "GEORGIA", name: "GEORGIA" },
    { value: "GERMANY", name: "GERMANY" },
    { value: "GREECE", name: "GREECE" },
    { value: "GUATEMALA", name: "GUATEMALA" },
    { value: "HONDURAS", name: "HONDURAS" },
    { value: "HONGKONG", name: "HONGKONG" },
    { value: "HUNGARY", name: "HUNGARY" },
    { value: "ICELAND", name: "ICELAND" },
    { value: "INDIA", name: "INDIA" },
    { value: "INDONESIA", name: "INDONESIA" },
    { value: "IRAN", name: "IRAN" },
    { value: "IRELAND", name: "IRELAND" },
    { value: "ISAREL", name: "ISAREL" },
    { value: "ITALY", name: "ITALY" },
    { value: "JAPAN", name: "JAPAN" },
    { value: "KAZAKHSTAN", name: "KAZAKHSTAN" },
    { value: "NORTH KOREA", name: "NORTH KOREA" },
    { value: "KORE AREPUBLIC", name: "REPUBLIC OF KOREA" },
    { value: "LATVIA", name: "LATVIA" },
    { value: "LEBANON", name: "LEBANON" },
    { value: "LIECHTENSTEIN", name: "LIECHTENSTEIN" },
    { value: "LITHUANIA", name: "LITHUANIA" },
    { value: "LUXEMBOURG", name: "LUXEMBOURG" },
    { value: "MACAU", name: "MACAU" },
    { value: "MACEDONIA", name: "MACEDONIA" },
    { value: "MALAYSIA", name: "MALAYSIA" },
    { value: "MEXICO", name: "MEXICO" },
    { value: "MONACO", name: "MONACO" },
    { value: "MOROCCO", name: "MOROCCO" },
    { value: "NETHERLANDS", name: "NETHERLANDS" },
    { value: "NEW ZEALAND", name: "NEW ZEALAND" },
    { value: "NORWAY", name: "NORWAY" },
    { value: "OMAN", name: "OMAN" },
    { value: "PAKISTAN", name: "PAKISTAN" },
    { value: "PANAMA", name: "PANAMA" },
    { value: "PERU", name: "PERU" },
    { value: "PHILIPPINES", name: "PHILIPPINES" },
    { value: "POLAND", name: "POLAND" },
    { value: "PORTUGAL", name: "PORTUGAL" },
    { value: "PUERTO RICO", name: "PUERTO RICO" },
    { value: "QATAR", name: "QATAR" },
    { value: "ROMANIA", name: "ROMANIA" },
    { value: "RUSSIA", name: "RUSSIA" },
    { value: "SAUDI ARABIA", name: "SAUDI ARABIA" },
    { value: "SINGAPORE", name: "SINGAPORE" },
    { value: "SLOVAKIA", name: "SLOVAKIA" },
    { value: "SLOVENIA", name: "SLOVENIA" },
    { value: "SOUTH AFRICA", name: "SOUTH AFRICA" },
    { value: "SPAIN", name: "SPAIN" },
    { value: "SWEDAN", name: "SWEDAN" },
    { value: "SWITZERLAND", name: "SWITZERLAND" },
    { value: "SYRIAN ARAB REPUBLIC", name: "SYRIAN ARAB REPUBLIC" },
    { value: "TAIWAN", name: "TAIWAN" },
    { value: "THAILAND", name: "THAILAND" },
    { value: "TRIANIDAD AND TOBAGO", name: "TRIANIDAD AND TOBAGO" },
    { value: "TUNISIA", name: "TUNISIA" },
    { value: "TURKEY", name: "TURKEY" },
    { value: "UKRAINE", name: "UKRAINE" },
    { value: "UNITED ARAB EMIRATES", name: "UNITED ARAB EMIRATES" },
    { value: "UNITED KINGDOM", name: "UNITED KINGDOM" },
    { value: "UNITED STATES", name: "UNITED STATES" },
    { value: "URUGUAY", name: "URUGUAY" },
    { value: "UZBEKISTAN", name: "UZBEKISTAN" },
    { value: "VENEZUELA", name: "VENEZUELA" },
    { value: "VIETNAM", name: "VIETNAM" },
    { value: "YEMEN", name: "YEMEN" },
    { value: "ZIMBABWE", name: "ZIMBABWE" },
    { value: "Undefined", name: "Undefined" }
];

export const WI_FI_5G_CHANNEL_MAPPING = {
    "ALBANIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "ALGERIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "ARGENTINA": [52, 56, 60, 64, 149, 153, 157, 161],
    "ARMENIA": [36, 40, 44, 48, 52, 56, 60, 64],
    "AUSTRALIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "AUSTRIA": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "AZERBAIJAN": [36, 40, 44, 48, 52, 56, 60, 64],
    "BAHRAIN": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "BELARUS": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "BELGIUM": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "BELIZE": [149, 153, 157, 161, 165],
    "BOLVIA": [149, 153, 157, 161, 165],
    "BRAZIL": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "BRUNEI DARUSSALAM": [149, 153, 157, 161, 165],
    "BULGARIA": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "CANADA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "CHILE": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "CHINA": [149, 153, 157, 161, 165],
    "COLOMBIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "COSTA RICA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "CROATIA": [36, 40, 44, 48, 52, 56, 60, 64],
    "CYPRUS": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "CZCH REPUBLIC": [36, 40, 44, 48, 52, 56, 60, 64],
    "DENMARK": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "DOMINICAN REPUBLIC": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "ECUADOR": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "EGYPT": [36, 40, 44, 48, 52, 56, 60, 64],
    "ELSALVADOR": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "FINLAND": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "FRANCE": [36, 40, 44, 48, 52, 56, 60, 64],
    "GEORGIA": [36, 40, 44, 48, 52, 56, 60, 64],
    "GERMANY": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "GREECE": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "GUATEMALA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "HONDURAS": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "HONGKONG": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "HUNGARY": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "ICELAND": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "INDIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "INDONESIA": [149, 153, 157, 161, 165],
    "IRAN": [149, 153, 157, 161, 165],
    "IRELAND": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "ISAREL": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "ITALY": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "JAPAN": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "KAZAKHSTAN": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "NORTH KOREA": [149, 153, 157, 161, 165],
    "KOREA REPUBLIC": [149, 153, 157, 161, 165],
    "LATVIA": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "LEBANON": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "LIECHTENSTEIN": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "LITHUANIA": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "LUXEMBOURG": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "MACAU": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "MACEDONIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "MALAYSIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "MEXICO": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "MONACO": [36, 40, 44, 48, 52, 56, 60, 64],
    "MOROCCO": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "NETHERLANDS": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "NEW ZEALAND": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "NORWAY": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "OMAN": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "PAKISTAN": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "PANAMA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "PERU": [149, 153, 157, 161, 165],
    "PHILIPPINES": [149, 153, 157, 161, 165],
    "POLAND": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "PORTUGAL": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "PUERTO RICO": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "QATAR": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "ROMANIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "RUSSIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "SAUDI ARABIA": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "SINGAPORE": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "SLOVAKIA": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "SLOVENIA": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "SOUTH AFRICA": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "SPAIN": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "SWEDAN": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "SWITZERLAND": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "SYRIAN ARAB REPUBLIC": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "TAIWAN": [52, 56, 60, 64, 149, 153, 157, 161],
    "THAILAND": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "TRIANIDAD AND TOBAGO": [36, 40, 44, 48, 52, 56, 60, 64],
    "TUNISIA": [36, 40, 44, 48, 52, 56, 60, 64],
    "TURKEY": [36, 40, 44, 48, 52, 56, 60, 64],
    "UKRAINE": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "UNITED ARAB EMIRATES": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "UNITED KINGDOM": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "UNITED STATES": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "URUGUAY": [149, 153, 157, 161, 165],
    "UZBEKISTAN": [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    "VENEZUELA": [149, 153, 157, 161, 165],
    "VIETNAM": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "YEMEN": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "ZIMBABWE": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    "Undefined": [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
};